<template>
  <main class="stockist">
    <h1 class="sli lundi b-b">Stockist</h1>
    <div class="text">
      <div class="li flex" v-for="shop in stockist" :key="shop.title">
        <div class="sli top lundi">{{ shop.title }}</div>
        <div class="sli top" v-html="shop.text"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "stockist",
  data() {
    return {
      lang: "en"
    };
  },
  created() {
    if (this.$store.state.stockist.length === 0) {
      this.$store.dispatch("loadStockist");
    }
  },
  computed: {
    stockist() {
      return this.$store.state.stockist;
    }
  }
};
</script>

<style lang="scss" scoped>
.stockist {
  font-feature-settings: none;
  .text {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: var(--lh);
    @media only screen and (max-width: 768px) {
      grid-template-columns: 1fr;
      .top {
        white-space: normal;
      }
    }
  }
}
</style>
